import { CachedChartActionTypes } from "models/actionTypes/cachedChartActionTypes";
import { RootActionType } from "models/actionTypes/rootActionTypes";
import { CachedChartsState } from "models/stateTypes/cachedChartsState";
import { ReduxConstants } from "utils/constants";

const initialState: CachedChartsState = {
  charts: {},
};

export const cachedChartReducer = (
  state: CachedChartsState = initialState,
  action: CachedChartActionTypes | RootActionType
) => {
  switch (action.type) {
    case ReduxConstants.RootActions.RESET:
      return initialState;
    case ReduxConstants.CachedChartsActions.RESET_CACHED_CHARTS:
      return { ...initialState };
    case ReduxConstants.CachedChartsActions.SET_CACHED_CHART:
      const newCachedCharts = { ...state.charts };
      newCachedCharts[action.payload.cacheKey] = action.payload;
      return {
        ...state,
        charts: newCachedCharts,
      };
    default:
      return state;
  }
};
